import React from "react";
import { usePoiItems } from "./usePoiItems";
import { GeojsonAttributes, useProjectShapeFile } from "./useProjectShapeFile";

export const useProjectMapOptions = ({ id }: { id: number | undefined }) => {
  const { vessels, hasPlan, planAreas, progressAreas } = useProjectShapeFile({
    id,
  });
  const { poiItems } = usePoiItems({ id });
  const [selectedColorOption, setSelectedColorOption] =
    React.useState<keyof GeojsonAttributes>("SubArea");

  const [vesselOptions, setVesselOptions] = React.useState<
    string[] | undefined
  >();
  const [areaOptions, setAreaOptions] = React.useState<string[] | undefined>();
  const [showPlanning, setShowPlanning] = React.useState<boolean>(hasPlan);
  const [showPoiMarkers, setShowPoiMarkers] = React.useState<boolean>(
    poiItems !== undefined && poiItems?.length > 0,
  );

  const checkBoxAreas = React.useMemo(
    () => (hasPlan && planAreas.length > 0 ? planAreas : progressAreas),
    [hasPlan, planAreas, progressAreas],
  );

  React.useEffect(() => {
    setShowPlanning(hasPlan);
  }, [hasPlan]);

  React.useEffect(() => {
    if (vessels) setVesselOptions(vessels);
  }, [vessels]);

  // if only progress is uploaded use areas of it instead of plan
  React.useEffect(() => {
    if (planAreas.length > 0) setAreaOptions(planAreas);
    else if (progressAreas && progressAreas.length > 0) {
      setAreaOptions(progressAreas);
    }
  }, [planAreas, progressAreas]);

  const projectMapOptions = React.useMemo(() => {
    if (!vesselOptions || !areaOptions) return null;
    return {
      vessels: vesselOptions,
      showPlanning,
      areaOptions,
      colorBy: selectedColorOption,
      planAreas,
    };
  }, [
    areaOptions,
    planAreas,
    selectedColorOption,
    showPlanning,
    vesselOptions,
  ]);

  return {
    selectedColorOption,
    setSelectedColorOption,
    vesselOptions,
    setVesselOptions,
    areaOptions,
    setAreaOptions,
    showPlanning,
    setShowPlanning,
    showPoiMarkers,
    setShowPoiMarkers,
    planAreas,
    checkBoxAreas,
    projectMapOptions,
  };
};
